/**
 * ThemeToggle Component
 * Sun/Moon animated switch for light/dark theme
 * Used inside the Header dropdown menu
 */

import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../../stores/theme.store';

export const ThemeToggle = () => {
  const { isDark, toggle } = useThemeStore();

  return (
    <div
      className="w-full flex items-center px-4 py-2 text-sm cursor-pointer"
      onClick={toggle}
    >
      {/* Sun/Moon combo icon */}
      <div className="h-4 w-4 mr-3 text-meta">
        {isDark ? (
          <Sun className="h-4 w-4" />
        ) : (
          <Moon className="h-4 w-4" />
        )}
      </div>

      {/* Label */}
      <span className="text-body flex-1">Theme</span>

      {/* Toggle switch */}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          toggle();
        }}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ${
          isDark ? 'bg-blue-600' : 'bg-white border border-gray-300'
        }`}
        aria-label="Toggle theme"
      >
        <span
          className={`inline-flex h-3.5 w-3.5 items-center justify-center rounded-full transition-transform duration-200 ${
            isDark
              ? 'translate-x-[18px] bg-white'
              : 'translate-x-[3px] bg-gray-400'
          }`}
        >
          {isDark ? (
            <Sun className="h-2.5 w-2.5 text-blue-600" />
          ) : (
            <Moon className="h-2.5 w-2.5 text-white" />
          )}
        </span>
      </button>
    </div>
  );
};
